import React, { useState } from 'react';
import {
  DataTable,
  TableHeader,
  TableBody,
  TableRow,
  TableColumn,
  Card,
  CardTitle,
  CardText,
  LinearProgress,
  TablePagination,
  TextField,
  Button,
  SelectField,
  Grid,
  DatePicker,
  FontIcon,
} from 'react-md';

import loanService from './../../../services/loan';

import DefaultLayout from './../../../components/layouts/default';
import './../styles.css';
import './../users.css';

const Audit = () => {

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [slicedData, setSlicedData] = useState([]);
  const [state, setState] = useState({
    title: 'Auditoría',
    codigo: '',
    operation: '',
    startAt: '',
    endAt: ''
  });

  // =======================================================
  /// Consulta la información del reporte
  // =======================================================
  const getData = async (limit=5000, offset=0) => {
    setLoading(true);
    setData([]);
    setSlicedData([]);
    let params = {
      internal_user: state.codigo,
      limit,
      offset,
    }
    if (state.operation !== '') {
      params = { ...params, operation: state.operation }
    }
    if (state.startAt !== '') {
      params = { ...params, start_at: state.startAt }
    }
    if (state.endAt !== '') {
      params = { ...params, end_at: state.endAt }
    }

    try {
      const response = await loanService.userTraces(params);

      console.log(response);

      if (response[0]) {
        const data = response.map(element => ({
          Usuario: element.username,
          Dispositivo: (element.so || element.device) ? `${element.so} ${element.device}` : 'Sin información',
          Operación: element.operation,
          'Código de barras': element.barcode,
          Resultado: element.result,
          Información: element.data,
          Fecha: element.inserted_at
        }));

        setData(data);
        setSlicedData(data.slice(0, 10));
        setState(prev => ({ ...prev, title: `Préstamos por: ${response[0].username}`}) );
      }
    } catch (error) {
      console.error(error);
    }

    setLoading(false);
  }

  // =======================================================
  /// Ejecuta el formulario de consulta de datos
  // =======================================================
  const handleSubmit = (event) => {
    event.preventDefault();
    getData();
  }

  // =======================================================
  /// Actualiza el listado de datos filtrados
  // =======================================================
  const handlePagination = (start, rowsPerPage) => {
    setSlicedData(data.slice(start, start + rowsPerPage));
  }

  // =======================================================
  /// Manipula los datos del estado para el formulario
  // =======================================================
  const handleInputsData = (data) => {
    setState(prev => ({ ...prev, ...data }));
  }

  return (
    <DefaultLayout>
      <Card>
        <CardTitle title={state.title} />
        <CardText>
          <form onSubmit={handleSubmit} className="profile-form audit-form">
            <Grid>
              <div className="md-cell md-cell--6 profile-box">
                <TextField
                  id="internal_user"
                  label="Código del estudiante"
                  lineDirection="center"
                  placeholder="Ingrese el código del estudiante"
                  value={state.codigo}
                  onChange={(value) => handleInputsData({codigo: value})}
                  required
                />
              </div>
              <div className="md-cell md-cell--6 profile-box">
                <SelectField
                  id='operation'
                  label="Operación"
                  placeholder="Seleccione para filtrar"
                  fullWidth
                  menuItems={[
                    { label: 'Todas', value: '' },
                    { label: 'SIP2 COPIES REPORT', value: 'SIP2 COPIES REPORT' },
                    { label: 'USER VALIDATE', value: 'USER VALIDATE' },
                    { label: 'WEB GENERAL LOAN REPORT', value: 'WEB GENERAL LOAN REPORT' },
                    { label: 'LOAN', value: 'LOAN' },
                  ]}
                  value={state.operation}
                  onChange={(value) => handleInputsData({ operation: value })}
                />
              </div>
              <div className="md-cell md-cell--6 profile-box">
                <DatePicker
                  id="date-picker-desde"
                  label="Desde"
                  autoOk
                  onChange={(value) => handleInputsData({ startAt: value.replace(/\//g, '-').split("-").reverse().join("-") })}
                  locales="es-ES"
                />
              </div>
              <div className="md-cell md-cell--6 profile-box">
                <DatePicker
                  id="date-picker-hasta"
                  label="Hasta"
                  autoOk
                  onChange={(value) => handleInputsData({ endAt: value.replace(/\//g, '-').split("-").reverse().join("-") })}
                  locales="es-ES"
                />
              </div>
              <Button type="submit" flat primary swapTheming>Buscar</Button>
            </Grid>
          </form>

        </CardText>
      </Card>

      <div className="users-table-container">
        <div className="users-table-header">
          <div className="users-table-header__left">
            <FontIcon className="users-table-header__icon">verified_user</FontIcon>
            <div>
              <h2 className="users-table-header__title">Resultados de auditoría</h2>
              <span className="users-table-header__subtitle">
                {data && data.length > 0 ? `${data.length} registros encontrados` : 'Sin registros'}
              </span>
            </div>
          </div>
        </div>

        {loading && <LinearProgress id="usersProgress" />}

        <div className="users-table-wrapper">
          <DataTable baseId="dynamic-content-desserts" className="users-data-table" plain>
            {(!data || data.length === 0) && (
              <TableBody>
                <TableRow className="users-table-body-row">
                  <TableColumn className="users-td" style={{ textAlign: 'center' }}>
                    Ingrese el identificador del usuario y luego presione "buscar"
                  </TableColumn>
                </TableRow>
              </TableBody>
            )}

            {data && data.length > 0 && (
              <React.Fragment>
                <TableHeader>
                  <TableRow className="users-table-head-row">
                    {Object.keys(data[0]).map((header) => (
                      <TableColumn key={header} className="users-th">{header}</TableColumn>
                    ))}
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {slicedData.map((item, i) => (
                    <TableRow key={i} className="users-table-body-row">
                      {Object.keys(item).map(key => (
                        <TableColumn key={key} className="users-td">{item[key]}</TableColumn>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
                <TablePagination
                  rows={data.length}
                  rowsPerPageLabel="Registros por página"
                  onPagination={handlePagination}
                />
              </React.Fragment>
            )}
          </DataTable>
        </div>
      </div>
    </DefaultLayout>
  );
}

export default Audit;
